import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  actionResult: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.new.spacing.small,
    width: '100%',
  },
  note: {
    margin: 0,
    ...theme.typography.small_body_regular,
    lineHeight: 1.6,
    color: theme.new.color.textPrimary,
    overflowWrap: 'anywhere',
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.new.spacing.xsmall,
    ...theme.typography.small_body_regular,
    color: theme.new.color.brand[600],
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  linkIcon: {
    fontSize: '1rem',
  },
}));

export default useStyles;
